import { render } from "./WebShopSuccess.vue?vue&type=template&id=31a40e27&scoped=true&ts=true"
import script from "./WebShopSuccess.vue?vue&type=script&lang=ts"
export * from "./WebShopSuccess.vue?vue&type=script&lang=ts"

import "./WebShopSuccess.vue?vue&type=style&index=0&id=31a40e27&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a40e27"]])

export default __exports__